export default __webpack_public_path__ + "static/media/Grips of Writhing.2fbef7d7.jpg";